import { render } from "./ProductSpecifications2.vue?vue&type=template&id=69b33d2c&scoped=true"
import script from "./ProductSpecifications2.vue?vue&type=script&lang=js"
export * from "./ProductSpecifications2.vue?vue&type=script&lang=js"

import "./ProductSpecifications2.vue?vue&type=style&index=0&id=69b33d2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b33d2c"]])

export default __exports__